module.exports = __webpack_public_path__ + "static/media/win-reward-A07.ed8ae9e7.png";